export default __webpack_public_path__ + "static/media/General_02.60067ed6.webp";